import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getReservationHistoryRequest,
  updateReservationTouchsaleSumRequest,
} from "../../services/reservationHistoryService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getReservationHistory(getReservationHistoryData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      getReservationHistoryRequest,
      token,
      getReservationHistoryData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_RESERVATIONS_HISTORY_SUCCESS,
        reservationHistory: response[1],
      });
    } else if (response[0] === 500) {
      yield put({
        type: actions.GET_RESERVATIONS_HISTORY_FAILURE,
      });
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      yield put({
        type: actions.GET_RESERVATIONS_HISTORY_FAILURE,
      });
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    yield put({
      type: actions.GET_RESERVATIONS_HISTORY_FAILURE,
    });
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* updateReservationTouchsaleSum({
  updateReservationTouchsaleSumData,
  refreshReservationHistoryData,
}) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      updateReservationTouchsaleSumRequest,
      token,
      updateReservationTouchsaleSumData
    );

    if (response[0] === 200) {
      yield put({
        type: actions.UPDATE_RESERVATION_TOUCHSALE_SUM_SUCCESS,
      });
      if (refreshReservationHistoryData) {
        yield put({
          type: actions.GET_RESERVATIONS_HISTORY_REQUEST,
          getReservationHistoryData: refreshReservationHistoryData,
        });
      }
      notification["success"]({
        message: "Успех",
        description: "Сумите на сметките са обновени.",
      });
    } else if (response[0] === 500) {
      yield put({
        type: actions.UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE,
      });
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      yield put({
        type: actions.UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE,
      });
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    yield put({
      type: actions.UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE,
    });
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.GET_RESERVATIONS_HISTORY_REQUEST,
      getReservationHistory
    ),
    yield takeEvery(
      actions.UPDATE_RESERVATION_TOUCHSALE_SUM_REQUEST,
      updateReservationTouchsaleSum
    ),
  ]);
}
